export enum StatusInventarioArquivo {
    PENDENTE = 'Pendente',
    PROCESSANDO = 'Processando',
    FINALIZADO = 'Finalizado',
    ERRO = 'Erro'
}